module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAGdJREFUOBHtlMENwCAMA03FOlmk+5Y5ykQUD4C4Sjx4EJHfKRDHQQJRIx4nQJUJ1KSbcGYuClLuFKRKjbn9NUw27B+fjZuVklSWttwf1g+IN6I5AXo2hYg0YZZO2XftXxD92N4AatoPI30SFseKyPcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dingyue.png
// module id = 670
// module chunks = 0